import { _ as _defineProperty } from '../../unsorted/defineProperty.js';
import { _ as _objectWithoutProperties } from '../../unsorted/objectWithoutProperties.js';
import { useMemo } from 'react';
import { m as merge } from '../../unsorted/index.js';
import { DEFAULT_LOADING_IMG_ATTR } from '../../constants.js';
import { jsx } from '@emotion/react/jsx-runtime';
import '@emotion/react';
import { C as CloudImage } from '../CloudImage/CloudImage.js';
import { i as isImageResizerProps } from '../../utils/imageHelpers2.js';

var _excluded = ["loading", "sx", "aspectRatio", "objectFit", "objectPosition", "testId", "className", "domRef", "alt", "use"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function convertOldFormatAspectRatio(aspectRatio) {
  return typeof aspectRatio === "string" ? aspectRatio.replace(":", "/") : aspectRatio;
}
function AspectRatioImage(_ref) {
  var _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? DEFAULT_LOADING_IMG_ATTR : _ref$loading,
    _ref$sx = _ref.sx,
    sx = _ref$sx === void 0 ? {} : _ref$sx,
    _ref$aspectRatio = _ref.aspectRatio,
    aspectRatio = _ref$aspectRatio === void 0 ? "1/1" : _ref$aspectRatio,
    _ref$objectFit = _ref.objectFit,
    objectFit = _ref$objectFit === void 0 ? "cover" : _ref$objectFit,
    _ref$objectPosition = _ref.objectPosition,
    objectPosition = _ref$objectPosition === void 0 ? "50% 50%" : _ref$objectPosition,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? "aspectRatioImage" : _ref$testId,
    className = _ref.className,
    domRef = _ref.domRef,
    alt = _ref.alt,
    use = _ref.use,
    props = _objectWithoutProperties(_ref, _excluded);
  var safeAspectRatio = useMemo(function () {
    if (Array.isArray(aspectRatio)) {
      return aspectRatio.map(function (aspect) {
        return convertOldFormatAspectRatio(aspect);
      });
    }
    return convertOldFormatAspectRatio(aspectRatio);
  }, [aspectRatio]);
  var mergedSx = useMemo(function () {
    return merge({
      aspectRatio: safeAspectRatio,
      objectFit: objectFit,
      objectPosition: objectPosition
    }, sx);
  }, [sx, safeAspectRatio, objectFit, objectPosition]);
  var typedProps = isImageResizerProps(use) ? props : _objectSpread({
    use: use
  }, props);
  return jsx(CloudImage, _objectSpread(_objectSpread({}, typedProps), {}, {
    domRef: domRef,
    alt: alt,
    loading: loading,
    className: "".concat(className !== null && className !== void 0 ? className : "", " AspectRatioImage"),
    testId: testId,
    sx: mergedSx
  }));
}
AspectRatioImage.displayName = "AspectRatioImage";

export { AspectRatioImage as A };
//# sourceMappingURL=AspectRatioImage.js.map
